<template>
  <a :rel="finalRel">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    isOpener: {
      type: Boolean,
      default: false,
    },
    rel: {
      type: String,
      default: "",
    },
  },
  computed: {
    finalRel() {
      if (this.isOpener) {
        return this.rel;
      } else {
        return "noopener " + this.rel;
      }
    },
  },
};
</script>
